import PropTypes from 'prop-types';
import {GEOMETRY_TYPES, LABEL_DISPLAY_TYPES} from 'Utils/constants';

const GeometryPropType = PropTypes.shape({
    type: PropTypes.oneOf(Object.values(GEOMETRY_TYPES)),
    coordinates: PropTypes.array,
});

const FeaturePropType = PropTypes.shape({
    type: PropTypes.oneOf(['Feature']).isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    properties: PropTypes.shape({
        boundaryGeometry: GeometryPropType, // to restrict the location of a display point
        bSideDictionaryItemId: PropTypes.string, // For digital signs
        bSideFeatureId: PropTypes.string, // For digital signs
        childrenIds: PropTypes.array,
        darkModeColor: PropTypes.string,
        dictionaryItemId: PropTypes.string,
        featureId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        featureType: PropTypes.object,
        groupId: PropTypes.string,
        isArea: PropTypes.bool,
        isAuditorium: PropTypes.bool,
        isBathroom: PropTypes.bool,
        isBuilding: PropTypes.bool,
        isCarEntrance: PropTypes.bool,
        isCheckin: PropTypes.bool,
        isDigitalSign: PropTypes.bool,
        isDisplayPoint: PropTypes.bool,
        isDoorway: PropTypes.bool,
        isDoubleSidedSign: PropTypes.bool,
        isEmergencyExit: PropTypes.bool,
        isExhibit: PropTypes.bool,
        isFitnessComplex: PropTypes.bool,
        isFoodOutlet: PropTypes.bool,
        isFootprint: PropTypes.bool,
        isFreeForm: PropTypes.bool,
        isGroup: PropTypes.bool,
        isHalfwayPoint: PropTypes.bool,
        isImportedLine: PropTypes.bool,
        isImportedPoint: PropTypes.bool,
        isImportedPolygon: PropTypes.bool,
        isKiosk: PropTypes.bool,
        isLevel: PropTypes.bool,
        isLibrary: PropTypes.bool,
        isMultiLevelCarpark: PropTypes.bool,
        isObject3d: PropTypes.bool,
        isOsmBuildings: PropTypes.bool,
        isParking: PropTypes.bool,
        isPoint: PropTypes.bool,
        isRetail: PropTypes.bool,
        isRoom: PropTypes.bool,
        isRouteSegment: PropTypes.bool,
        isSectionSeating: PropTypes.bool,
        isShower: PropTypes.bool,
        isSnapLine: PropTypes.bool,
        isSnapPoint: PropTypes.bool,
        isStadium: PropTypes.bool,
        isVillage: PropTypes.bool,
        isThreshold: PropTypes.bool,
        isUniversity: PropTypes.bool,
        isVenueEntrance: PropTypes.bool,
        isVoid: PropTypes.bool,
        isWall: PropTypes.bool,
        isRoad: PropTypes.bool,
        labelDisplayType: PropTypes.oneOf(Object.values(LABEL_DISPLAY_TYPES)),
        lightModeColor: PropTypes.string,
        locationId: PropTypes.string,
        locked: PropTypes.bool,
        oneWay: PropTypes.bool,
        sceneProperties: PropTypes.object,
    }).isRequired,
    geometry: GeometryPropType.isRequired,
});

export default FeaturePropType;
